export default {
    tel_number: {
        max: 11,
        min: 10
    },
    voices_expire_default: {
        Business: 365,
        Customer: 365
    }
}
